'use strict';

const inspectable = require('../rlink-inspectable-error');

const EmbeddedValue = require('./storage/EmbeddedValue');

module.exports = function areEmbeddedValues (values) {
  if (values.some(v => v instanceof EmbeddedValue)) {
    if (!values.every(v => v instanceof EmbeddedValue)) {
      throw inspectable`Inconsistent ${{ values }} - at least one value is an EmbeddedValue but some are not!`;
    }

    return true;
  }

  return false;
};



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/areEmbeddedValues.js